
const countries = [
  { name: 'Venezuela', code: 've' },
  { name: 'Colombia', code: 'co' },
  { name: 'Mexico', code: 'mx' },
  { name: 'Argentina', code: 'ar' },
  { name: 'Chile', code: 'cl' },
  { name: 'Peru', code: 'pe' },
  { name: 'Ecuador', code: 'ec' },
  { name: 'Costa Rica', code: 'cr' },
];

export default function LatAmFlags() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Reach
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
            Sourcing Across Latin America
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We connect U.S. companies with trusted suppliers throughout the region
          </p>
        </div>
        <div className="flex justify-start lg:justify-center items-center gap-8 lg:gap-12 overflow-x-auto pb-4 lg:pb-0 scrollbar-hide">
          {countries.map((country) => (
            <div
              key={country.code}
              className="flex flex-col items-center gap-2 group flex-shrink-0"
            >
              <div className="w-16 h-16 rounded-full overflow-hidden shadow-md border-2 border-gray-100 group-hover:border-orange-400 transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-lg">
                <img
                  src={`https://flagcdn.com/w160/${country.code}.png`}
                  alt={`${country.name} flag`}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-xs font-medium text-gray-600 group-hover:text-orange-600 transition-colors whitespace-nowrap">
                {country.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
